class HomeController {

    static $inject = ["$location", "stToast", "tpsrService"];

    constructor($location, stToast, tpsrService) {
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.user = {
            email: null,
            password: null
        };
    }

    $onInit() {
        if (this.tpsr.isLoggedIn()) 
            this._loginRedirect();
    }

    loginEnabled = () => {
        if (!this.user.email)
            return false;

        if (!this.user.password)
            return false;

        return true;
    }

    login = () => {
        return this.tpsr.login(this.user.email, this.user.password)
            .then(result => {
                if (result.logged_in)
                    this._loginRedirect();
                else
                    this.toast.error("Login failed.", result.reason);
            });
    }

    _loginRedirect = () => {
        if (this.tpsr.user.is_npc_admin)
            this.$location.url("/npc-admins");
        else if (this.tpsr.user.is_admin || this.tpsr.user.is_approver)
            this.$location.url("/users");
        else
            this.$location.url("/orders");
    };
}

angular
    .module("app")
    .component("home", {
        templateUrl: "src/app/home/home.html",
        controller: HomeController
    });
